export const SUBSCRIPTION_TYPE = {
    FLAT: "flat",
    PAYG: "payg",
};
